/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Int32ApiRespModel } from '../../models/int-32-api-resp-model';

export interface ApiMasterLicenseTypeDeleteGet$Params {
  id?: number;
}

export function apiMasterLicenseTypeDeleteGet(http: HttpClient, rootUrl: string, params?: ApiMasterLicenseTypeDeleteGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Int32ApiRespModel>> {
  const rb = new RequestBuilder(rootUrl, apiMasterLicenseTypeDeleteGet.PATH, 'get');
  if (params) {
    rb.query('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Int32ApiRespModel>;
    })
  );
}

apiMasterLicenseTypeDeleteGet.PATH = '/api/Master/LicenseType/Delete';
